module.exports = __webpack_public_path__ + "sprite/buttons.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons.json
// module id = 85
// module chunks = d-game